import Vue from 'vue';
import Router from 'vue-router';
import layout from '@/layout/index';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      component: layout,   // 套用同一个模板  
      children: [
        {
          path: '/',
          name: 'index',
          component: (resolve) => require(['@/pages/index/index'], resolve)
        }, {
          path: '/iot',
          name: 'iot',
          component: (resolve) => require(['@/pages/iot/index'], resolve)
        }, {
          path: '/solution',
          name: 'solution',
          component: (resolve) => require(['@/pages/solution/index'], resolve)
        }, {
          path: '/solutionDetail',
          name: 'solutionDetail',
          component: (resolve) => require(['@/pages/solutionDetail/index'], resolve)
        }, {
          path: '/case',
          name: 'case',
          component: (resolve) => require(['@/pages/case/index'], resolve)
        }, {
          path: '/about',
          name: 'about',
          component: (resolve) => require(['@/pages/about/index'], resolve)
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    if (savedPosition) {
      return savedPosition
     } else {
      return { x: 0, y: 0 }
     }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js